import React from 'react';
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const fadeInVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (delay: number = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut', delay },
  }),
};

export const MissionVision: React.FC = () => {
  const headingSize = useBreakpointValue({ base: '2xl', md: '3xl' });

  return (
    <Box py={24} px={{ base: 6, md: 24 }} bg="white" color="black">
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={16}>
        <MotionBox
          custom={0}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInVariant}
          borderLeft="3px solid #CF0000"
          pl={6}
        >
          <Heading
            as="h2"
            fontSize={headingSize}
            fontWeight="medium"
            textTransform="uppercase"
            letterSpacing="wider"
            color="#CF0000"
            mb={4}
          >
            Our Mission
          </Heading>
          <Text fontSize="md" color="gray.800" lineHeight="taller" opacity={0.85}>
            To provide personalized educational guidance that empowers students to achieve academic and career excellence through international study.
          </Text>
        </MotionBox>

        <MotionBox
          custom={0.2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInVariant}
          borderLeft="3px solid #CF0000"
          pl={6}
        >
          <Heading
            as="h2"
            fontSize={headingSize}
            fontWeight="medium"
            textTransform="uppercase"
            letterSpacing="wider"
            color="#CF0000"
            mb={4}
          >
            Our Vision
          </Heading>
          <Text fontSize="md" color="gray.800" lineHeight="taller" opacity={0.85}>
            To be the most trusted academic partner for students seeking global education opportunities by delivering expert support and fostering lifelong success.
          </Text>
        </MotionBox>
      </SimpleGrid>
    </Box>
  );
};
